import axiosInstance from "app/axiosInstance";
import { KeyActionRequestDto } from "../entities/dtos/key-action-request.dto";

export const deleteKey = async ({ accountId, keyId }: KeyActionRequestDto) => {
  try {
    const response = await axiosInstance.delete(
      `/accounts/${accountId}/keys/${keyId}/delete`
    );

    return response;
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
